// extracted by mini-css-extract-plugin
export var cell = "StakeStrip-module--cell--aa0f3";
export var cellField = "StakeStrip-module--cellField--db162";
export var cellFieldLocked = "StakeStrip-module--cellFieldLocked--db800";
export var cellPromo = "StakeStrip-module--cellPromo--b0258";
export var inner = "StakeStrip-module--inner--c0132";
export var label = "StakeStrip-module--label--aba83";
export var quickStake = "StakeStrip-module--quickStake--6a822";
export var separator = "StakeStrip-module--separator--8032f";
export var separatorBadge = "StakeStrip-module--separatorBadge--3c72b";
export var stakePulse = "StakeStrip-module--stakePulse--cbdb8";
export var strip = "StakeStrip-module--strip--e513e";
export var value = "StakeStrip-module--value--8f680";